import React from 'react';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';
import { useNavigate } from 'react-router-dom';
import { useI18n } from '@/i18n';
import './home.css';

const Home = () => {
  const navigate = useNavigate();
  const { t } = useI18n();
  useDocumentTitle(t('app.title'));
  return (
    <div className="home-page">
      {/* Main Content */}
      <div className="welcome-container">
        <div className="welcome-box">
          <h1 className="welcome-title">{t('home.welcomeTitle')}</h1>
          
          <div className="buttons-container">
            <button 
              className="btn btn-login"
              onClick={() => navigate('/login')}
            >
              {t('home.login')}
            </button>
            
            <button 
              className="btn btn-register"
              onClick={() => navigate('/register')}
            >
              {t('home.register')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
